import { Component } from '@angular/core';

@Component({
    selector: 'zwi-embed-sermon-list-container',
    imports: [],
    templateUrl: './embed-sermon-list-container.component.html',
    styleUrl: './embed-sermon-list-container.component.scss'
})
export class EmbedSermonListContainerComponent {}
